<div class="item">
    <img *ngIf="amenity?.Name && imageName" 
        class="about-site-amentities-icon"
        [src]="'assets/images/SiteDetails/AmenitiesIcons/' + imageName"
        [alt]="amenity.ImageName">
    <span class="about-site-amenities-text">{{amenity.Name}}</span>
</div>